import React from 'react';
import I18n from 'i18n-js';
import experiments from '../experiments';
import CspCollection from '../cms/components/csp_collection';
import { US_CON } from '../constants';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import { MParticleEventName } from '../elog/mparticle_types';
import { reverb_search_CSPSearchRequest_Sort, reverb_search_ListingsSearchRequest_Sort } from '../rql';
import { experimentInt } from '../user_context_helpers';
import { useUser } from '../user_hooks';
import { useViewTracking } from '../use_tracking';
import CmsListingsCollection from '../cms/components/cms_listings_collection';
import { CmsEmbed } from './cms_embed';

interface ExperimentalMosaicRowProps {
  children: React.ReactElement<CmsEmbed>;
}

export function BestSellers() {
  return (
    <CspCollection
      title={I18n.t('commons.homepage.bestSellers')}
      trackingName="HomepageBestSellers"
      sort={reverb_search_CSPSearchRequest_Sort.RECENT_ORDERS_COUNT_DESC}
      maxCount={12}
      ssr={false}
    />
  );
}

export function Free2DayShipping() {
  const user = useUser();

  return (
    <CmsListingsCollection
      title={I18n.t('commons.homepage.free2DayShipping')}
      freeExpeditedShipping
      userShippingRegion={user.shippingRegionCode}
      priceMin="99"
      priceMax="2500"
      trackingName="HomepageFree2DayShipping"
      categoryUuids={[
        '3ca3eb03-7eac-477d-b253-15ce603d2550', // acoustic guitars
        '09055aa7-ed49-459d-9452-aa959f288dc2', // amps
        '53a9c7d7-d73d-4e7f-905c-553503e50a90', // bass guitars
        'b3cb9f8e-4cb6-4325-8215-1efcd9999daf', // drums and percussion
        'fa10f97c-dd98-4a8f-933b-8cb55eb653dd', // effects and pedals
        'dfd39027-d134-4353-b9e4-57dc6be791b9', // electric guitars
        'd002db05-ab63-4c79-999c-d49bbe8d7739', // keyboards and synths
        'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e', // pro audio
      ]}
      ctaTargetHref="/c/free-2-day-shipping"
      sort={reverb_search_ListingsSearchRequest_Sort.WATCHERS_COUNT_DESC}
      maxCount={12}
      largeTiles
      ssr={false}
    />
  );
}

export function ExperimentalMosaicRow(props: ExperimentalMosaicRowProps) {
  const user = useUser();
  const { children } = props;
  const experiment = experiments.REPLACE_MOSAIC_HOMEPAGE_ROW;
  const expGroup = experimentInt(user, experiment);

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: 'ExperimentalMosaicRow',
    experiments: formatExperimentsForEventAttributes(user, [experiment]),
  }, true);

  if (expGroup === 1) {
    return <BestSellers />;
  } else if (expGroup === 2 && user.shippingRegionCode === US_CON) {
    return <Free2DayShipping />;
  }

  return children;
}
